module.exports = __webpack_public_path__ + "img/funding-new10.ce7c002d.png";